import React from 'react';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';
import { BUTTON_TYPE, VARIANT } from '@motorway/mw-highway-code/enums';

import { Content } from 'LegacySBCRA/Content/Content';

import kwikFitLogo from '../../../../../../client/assets_seller/partners/kwikfit.png';
import { useCheckerToolsAnalytics } from '../../Hooks/useCheckerToolsAnalytics';
import { CHECKER_TOOLS_PAGE_SECTIONS, usePageRefEvents } from '../../Pages/CheckerRouter.utils';
import LocalTexts from '../../texts.json';

import styles from './BookMOT.scss';

const LocalT = new MDText(LocalTexts);

const translate = (key: string) => LocalT.translate(key) as string;

export const KWIK_FIT_BOOKING_URL = 'https://kwikfit.82rc.net/5kLRkL';

type BookMOTProps = {
  onLoad: () => void;
};

export const BookMOT = ({ onLoad }: BookMOTProps) => {
  const { setRef } = usePageRefEvents({ onRefTrigger: onLoad });
  const { triggerAnalyticsCtaClick } = useCheckerToolsAnalytics();

  const ctaLabel = translate('bookMot.ctaLabel');

  const onCtaClick = () => {
    triggerAnalyticsCtaClick({
      buttonLabel: ctaLabel,
      label: CHECKER_TOOLS_PAGE_SECTIONS.KWIK_FIT,
      name: CHECKER_TOOLS_PAGE_SECTIONS.KWIK_FIT,
      url: KWIK_FIT_BOOKING_URL,
    });
  };

  return (
    <Content className={styles.contentWrapper}>
      <div ref={(ref) => setRef(ref)} className={styles.component} data-testid='book-mot'>
        <h2 className={styles.title}>{translate('bookMot.title')}</h2>
        <p data-thc-style-override className={styles.description}>{translate('bookMot.description')}</p>
        <div className={styles.ctaContainer}>
          <Button
            fullWidth
            as='a'
            href={KWIK_FIT_BOOKING_URL}
            label={ctaLabel}
            onClick={onCtaClick}
            rel='noopener noreferrer sponsored'
            target='_blank'
            type={BUTTON_TYPE.BUTTON}
            variant={VARIANT.PRIMARY}
          />
        </div>
        <p data-thc-style-override className={styles.partnership}>
          <span>{translate('bookMot.partnership')}</span>
          <img alt={translate('bookMot.logoAlt')} height='24' loading='lazy' src={kwikFitLogo} width='122' />
        </p>
      </div>
    </Content>
  );
};
